// Polyfills.
import "core-js/es6/symbol"
import "core-js/es6/object"
import "core-js/es6/function"
import "core-js/es6/parse-int"
import "core-js/es6/parse-float"
import "core-js/es6/number"
import "core-js/es6/math"
import "core-js/es6/string"
import "core-js/es6/date"
import "core-js/es6/array"
import "core-js/es6/regexp"
import "core-js/es6/map"
import "core-js/es6/weak-map"
import "core-js/es6/set"
import "element-closest-polyfill"
require("classlist-polyfill");

import Vue from "vue"
import App from "@/App.vue"
import Arr from "@/lib/Arr"
import axios from "@/lib/Axios"
import events from "@/events"
import router from "@/router"
import store from "@/store"
import Html from "@/lib/Html"
import moment from "moment"

// Global Mixins.
import EventBusMixins from "@/mixins/EventBus"
import HtmlMixins from "@/mixins/Html"
import MessageMixins from "@/mixins/Message"
import ModalMixins from "@/mixins/Modal"
import RoutesMixins from "@/mixins/Routes"
import SurveyMixins from "@/mixins/Survey"

// Plugins
import VueScrollTo from "vue-scrollto"
import {scroller} from "vue-scrollto/src/scrollTo"
import VueGtm from 'vue-gtm';

Vue.config.productionTip = false;

Vue.mixin(EventBusMixins);
Vue.mixin(HtmlMixins);
Vue.mixin(MessageMixins);
Vue.mixin(ModalMixins);
Vue.mixin(RoutesMixins);
Vue.mixin(SurveyMixins);

Vue.use(VueScrollTo);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY,
  enabled: true,
  debug: false
});

const queryString = require("query-string");

window._ = require("lodash");
window.axios = axios;
window.Arr = Arr;
window.Events = events;
window.moment = moment;
window.queryString = window.location.search ? queryString.parse(window.location.search) : {};
window.scroller = scroller;

Html.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
